module.exports = __webpack_public_path__ + "public/files/img/teachers.b3924f39.gif";